var map = {
	"./arrows.svg": 2198,
	"./avatar.svg": 3048,
	"./bills/bulb.svg": 1943,
	"./bills/diamond.svg": 6661,
	"./bills/network.svg": 6769,
	"./bills/phone.svg": 9762,
	"./bills/tv.svg": 3198,
	"./bills/water.svg": 5641,
	"./checkmark.svg": 5280,
	"./crown.svg": 3917,
	"./gtb.svg": 3569,
	"./landing_page/lock.svg": 4702,
	"./landing_page/lock_circle.svg": 2448,
	"./landing_page/mail.svg": 5695,
	"./landing_page/mail2.svg": 8629,
	"./link.svg": 846,
	"./link2.svg": 549,
	"./list.svg": 7468,
	"./list1.svg": 5064,
	"./list3.svg": 8218,
	"./list4.svg": 7267,
	"./logo.svg": 2835,
	"./logo_dark.svg": 1432,
	"./logo_white.svg": 6784,
	"./menu/money-check.svg": 234,
	"./pound.svg": 7552,
	"./pound3.svg": 6086,
	"./printer.svg": 5775,
	"./printer2.svg": 1952,
	"./receipt.svg": 7313,
	"./rectangle.svg": 3420,
	"./sterling.svg": 3593,
	"./voucher.svg": 7566,
	"./wema.svg": 3786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;